/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/const/AnsiColors.ts
 * @create:      2021-12-23 17:55:28.084
 * @modify:      2025-07-11 20:47:10.778
 * @version:     6.0.0
 * @times:       24
 * @lines:       92
 * @copyright:   Copyright © 2021-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

export const AnsiColors_Reset = "\u001b[0m";

export const AnsiColors_Black = "\u001b[30m";
export const AnsiColors_Red = "\u001b[31m";
export const AnsiColors_Green = "\u001b[32m";
export const AnsiColors_Yellow = "\u001b[33m";
export const AnsiColors_Blue = "\u001b[34m";
export const AnsiColors_Magenta = "\u001b[35m";
export const AnsiColors_Cyan = "\u001b[36m";
export const AnsiColors_White = "\u001b[37m";

export const AnsiColors_BrightBlack = "\u001b[30;1m";
export const AnsiColors_BrightRed = "\u001b[31;1m";
export const AnsiColors_BrightGreen = "\u001b[32;1m";
export const AnsiColors_BrightYellow = "\u001b[33;1m";
export const AnsiColors_BrightBlue = "\u001b[34;1m";
export const AnsiColors_BrightMagenta = "\u001b[35;1m";
export const AnsiColors_BrightCyan = "\u001b[36;1m";
export const AnsiColors_BrightWhite = "\u001b[37;1m";

export const AnsiColors_Background_Black = "\u001b[40m";
export const AnsiColors_Background_Red = "\u001b[41m";
export const AnsiColors_Background_Green = "\u001b[42m";
export const AnsiColors_Background_Yellow = "\u001b[43m";
export const AnsiColors_Background_Blue = "\u001b[44m";
export const AnsiColors_Background_Magenta = "\u001b[45m";
export const AnsiColors_Background_Cyan = "\u001b[46m";
export const AnsiColors_Background_White = "\u001b[47m";

export const AnsiColors_Background_BrightBlack = "\u001b[40;1m";
export const AnsiColors_Background_BrightRed = "\u001b[41;1m";
export const AnsiColors_Background_BrightGreen = "\u001b[42;1m";
export const AnsiColors_Background_BrightYellow = "\u001b[43;1m";
export const AnsiColors_Background_BrightBlue = "\u001b[44;1m";
export const AnsiColors_Background_BrightMagenta = "\u001b[45;1m";
export const AnsiColors_Background_BrightCyan = "\u001b[46;1m";
export const AnsiColors_Background_BrightWhite = "\u001b[47;1m";

/**
 * Generates an ANSI escape code string to set the foreground text color
 * using the 256-color palette.
 *
 * @param id - The color ID (0-255) from the ANSI 256-color palette.
 * @returns The ANSI escape code string for the specified color.
 */
export function AnsiColor256(id: number) {
    return `\u001b[38;5;${id}m`;
}

/**
 * Generates an ANSI escape code string to set the background color
 * using a 256-color palette in the terminal.
 *
 * @param id - The color ID (0-255) from the ANSI 256-color palette.
 * @returns The ANSI escape code string for the specified background color.
 */
export function AnsiColorBackground256(id: number) {
    return `\u001b[48;5;${id}m`;
}
